import { applyMiddleware, createStore, combineReducers } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";

import { reducer as profileReducer } from "./redux/reducers/profile";
import { reducer as adminMetricsReducer } from "./redux/reducers/admin/metrics";
import { reducer as subscriptionReducer } from "./redux/reducers/subscription";
import { reducer as flashMessageReducer } from "./redux/reducers/flashMessage";
import { reducer as messagesReducer } from "./redux/reducers/messages";
import { reducer as educationReducer } from "./redux/reducers/education";
import { reducer as workExperienceReducer } from "./redux/reducers/workExperience";
import { reducer as skillReducer } from "./redux/reducers/skill";
import { reducer as resumeReducer } from "./redux/reducers/resume";
import { reducer as storeReducer } from "./redux/reducers/store";
import { reducer as contactReducer } from "./redux/reducers/contact";
import internationalize from "./redux/reducers/internationalize";
import job from "./redux/reducers/job";
import user from "./redux/reducers/user";
import alert from "./redux/reducers/alert";

const middlewares = [thunk];

const rootReducer = combineReducers({
  profile: profileReducer,
  admin: adminMetricsReducer,
  flashMessages: flashMessageReducer,
  subscription: subscriptionReducer,
  messages: messagesReducer,
  education: educationReducer,
  workExperience: workExperienceReducer,
  skill: skillReducer,
  resume: resumeReducer,
  store: storeReducer,
  contact: contactReducer,
  ...job,
  ...user,
  ...alert,
  ...internationalize,
});

export default createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(...middlewares))
);
